import React, { useEffect } from 'react';
import { useAnimation, motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export const Reveal = ({ children }) => {
  const [inViewRef, inView] = useInView({ triggerOnce: true });

  const mainControls = useAnimation();
  const slideControls = useAnimation();

  useEffect(() => {
    if (inView) {
      mainControls.start('visible');
      slideControls.start('visible');
    }
  }, [inView, mainControls, slideControls]);

  return (
    <div ref={inViewRef} className="relative w-full overflow-hidden">
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 75 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 0.5, delay: 0.25 }}
      >
        {children}
      </motion.div>
      <motion.div
        variants={{
          hidden: { left: 0 },
          visible: { left: '100%' },
        }}
        initial="hidden"
        animate={slideControls}
        transition={{ duration: 0.5, ease: 'easeIn' }}
        className="absolute bottom-1 left-0 right-0 top-1 z-20 bg-gradient-to-r from-indigo-600/30 via-violet-600/30 to-indigo-600/30 backdrop-blur-sm"
      />
    </div>
  );
};